var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"600px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }